import { rankingItems } from '@/mocks/home';

const rankColors: Record<number, string> = {
  1: 'bg-primary-500 text-background-50',
  2: 'bg-primary-400 text-background-50',
  3: 'bg-primary-300 text-background-50',
  4: 'bg-foreground-200 text-foreground-700',
  5: 'bg-foreground-200 text-foreground-700',
  6: 'bg-foreground-200 text-foreground-700',
};

export default function Ranking() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
          热播榜单
        </h2>
        <div className="max-w-[700px] mx-auto bg-background-100 rounded-2xl overflow-hidden">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 px-5 py-4 ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/60' : ''
              } hover:bg-primary-50/20 transition-colors cursor-pointer`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${rankColors[item.rank]}`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-heading text-sm font-semibold text-foreground-900 truncate">{item.title}</div>
                <div className="text-xs text-foreground-500">{item.tag}</div>
              </div>
              <div className="text-right flex-shrink-0">
                <div className="text-xs text-foreground-600">{item.heat}</div>
                <div className="text-xs mt-0.5">
                  {item.change === 'up' ? (
                    <span className="text-primary-500"><i className="ri-arrow-up-line"></i> 上升</span>
                  ) : (
                    <span className="text-accent-600"><i className="ri-sparkling-line"></i> 新晋</span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}